<!-- @format -->

<template>
	<el-color-picker v-model="value" show-alpha :predefine="predefineColors" />
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value || '');
		},
	});

	const predefineColors = ref([
		'#ff4500',
		'#ff8c00',
		'#ffd700',
		'#90ee90',
		'#00ced1',
		'#1e90ff',
		'#c71585',
		'rgba(255, 69, 0, 0.68)',
		'rgb(255, 120, 0)',
		'hsv(51, 100, 98)',
		'hsva(120, 40, 94, 0.5)',
		'hsl(181, 100%, 37%)',
		'hsla(209, 100%, 56%, 0.73)',
		'#c7158577',
	]);
</script>

<style scoped></style>
